import styles from "./styles.module.css";
import { Fragment, useState } from "react";
import InfoIcon from "@mui/icons-material/Info";
import { IconButton } from "@mui/material";

const TableRelatorio = ({ data, handleOpenModalDetalhes }) => {
  return (
    <>
      {data.length > 0 ? (
        <table className={styles.accordion_table}>
          <thead>
            <tr>
              <th>CNPJ</th>
              <th>Tipo</th>
              <th>Status</th>
              <th>Usuário</th>
              <th>Dt. Pedido</th>
              <th>Dt. Início Sped</th>
              <th>Dt. Fim Sped</th>
              <th style={{ display: "none" }}></th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <Fragment key={index}>
                <tr className={styles.accordion_summary}>
                  <td>{row.cnpj}</td>
                  <td>{row.tipoSped}</td>
                  {row.status == "Aguardando na fila" && (
                    <td>
                      <span className={styles.status_container}>
                        <span className={styles.fila} /> Aguardando na fila
                      </span>
                    </td>
                  )}
                  {row.status == "Processando" && (
                    <td>
                      <span className={styles.status_container}>
                        <span className={styles.processando} /> Processando
                      </span>
                    </td>
                  )}
                  {row.status == "Sucesso" && (
                    <td>
                      <span className={styles.status_container}>
                        <span className={styles.sucesso} /> Sucesso
                      </span>
                    </td>
                  )}
                  {row.status == "Erro" && (
                    <td>
                      <span className={styles.status_container}>
                        <span className={styles.erro} /> Erro
                      </span>
                    </td>
                  )}
                  <td>{row.usuario}</td>
                  <td>{row.dt_inicio_processo}</td>
                  <td>{row.dt_inicio_sped}</td>
                  <td>{row.dt_fim_sped}</td>
                  <td>
                    <IconButton
                      sx={{ color: "#18316e" }}
                      aria-label="info"
                      onClick={() => {
                        handleOpenModalDetalhes(row);
                      }}
                    >
                      <InfoIcon />
                    </IconButton>
                  </td>
                </tr>
              </Fragment>
            ))}
          </tbody>
        </table>
      ) : (
        <h3 className={styles.aviso_vazio}>Nenhum item encontrado!</h3>
      )}
    </>
  );
};

export default TableRelatorio;
